

import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {useStore} from "vuex";
import zaloRepository from "@/services/ZaloRepository";
import moment from "moment";
import Province from "@/models/province.models";
import Ward from "@/models/Ward.models";
import teamRepository from "@/services/TeamRepository";
import {CustomerUpdateByWeb} from "@/models/customerUpdateByWeb";

export default {
  props: {
    id: String,
  },

  setup(props){
    const router = useRouter();
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const customerUpdate = ref({} as CustomerUpdateByWeb);
    const date = ref("");
    const listWard = ref([] as Ward[]);
    const listProvince = ref([] as Province[]);
    const ward = ref({} as Ward);
    const province = ref({} as Province);


    const doRegister = () => {
      customerUpdate.value.ZaloId = props.id;
      customerUpdate.value.wardCode = ward.value.wardCode;
      customerUpdate.value.provinceCode = province.value.provinceCode;
        zaloRepository.updateCustomerByWeb(customerUpdate.value)
            .then((response) => {
              toast.add({
                severity: 'success',
                summary: 'Đăng ký',
                detail: 'Đăng ký thành viên thành công vào hệ thống',
                life: 2000
              });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 5000
              });
            });
    }

    teamRepository.getListProvince()
        .then((response) => {
          listProvince.value = response.data;
        })
        .catch();
    const loadListWard = () => {
      console.log("@@@############### debug province: " + JSON.stringify(province.value));
      teamRepository.getListWardById(province.value.provinceCode)
          .then((response) => {
            listWard.value= response.data;
          })
          .catch();
    }
    const valid = computed(()=> customerUpdate.value.FullName && customerUpdate.value.PhoneNumber?.length >=10 && ward.value.wardCode);
    return {
      date,
      customerUpdate,
      doRegister,
      valid,
      listWard,
      listProvince,
      ward,
      province,
      loadListWard,
    }
  }
}

